import React from 'react';
import { Search, Filter, Calendar } from 'lucide-react';

interface EmailFiltersProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  selectedDeal: string;
}

export default function EmailFilters({
  searchTerm,
  onSearchChange,
  selectedDeal
}: EmailFiltersProps) {
  return (
    <div className="p-4 border-b border-gray-200">
      <div className="flex items-center space-x-4">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type="text"
            placeholder="Search emails..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <select
          className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">All Types</option>
          <option value="due_diligence">Due Diligence</option>
          <option value="negotiation">Negotiation</option>
          <option value="legal">Legal</option>
          <option value="financial">Financial</option>
        </select>

        <button
          className="flex items-center px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
        >
          <Calendar className="w-4 h-4 mr-2" />
          Date Range
        </button>
      </div>
    </div>
  );
}